import React, { Suspense, lazy } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';

// Todo lo que está bajo el pliegue se carga en un chunk aparte:
// el lead ve el hero de inmediato y el resto llega en segundo plano.
const BelowFold = lazy(() => import('./components/BelowFold').then(module => ({
  default: module.BelowFold
})));
export function App() {
  return <div className="w-full bg-ink-900 font-heading text-bone antialiased selection:bg-gold-400/30 selection:text-gold-100" data-id="element-0" data-mp="2rk45p1wykwfy">
      <UrgencyBar data-id="element-1" data-mp="2mn5fgugf19n1" />
      <main data-id="element-2" data-mp="2mnne1xqjvzy4">
        <Hero data-id="element-3" data-mp="2mjzo18kbdvo5" />
        <Suspense fallback={<div className="h-32 w-full bg-ink-950" aria-hidden="true" data-id="element-5" data-mp="31aysc7e49y1x" />} data-id="element-4" data-mp="31agn4l9h89hv">
          <BelowFold data-id="element-6" data-mp="2wk0bn6p7uxy5" />
        </Suspense>
      </main>
    </div>;
}